import './style.sass';
import React, { useEffect, useRef } from 'react';
import { useOnClickOutside } from 'app/hooks/useOnClickOutside';
import { toggleModal } from 'app/utils/toggleModal';

type Props = React.PropsWithChildren<{
    onClose: () => void,
}>;

export const Modal = ({ onClose, children }: Props) => {
    const contentRef = useRef(null);

    useOnClickOutside(contentRef, onClose);

    useEffect(() => {
        toggleModal();

        return () => toggleModal();
    }, []);

    return (
        <div className="modal">
            <div className="modal__content" ref={contentRef}>
                {children}
            </div>
        </div>
    );
};
